import React from "react";
import {
  convertToLowerCase,
  getADHDImage,
  getAntiSocialReportPageImage,
  getAttachmentStyleReportPageImage,
  getSocialAnxietyReportPageImage,
  getAutismAdultReportPageImage,
  getAutismChildPageImage,
  getBipolarDisorderImage,
  getChildhoodPageImage,
  getDifficultPersonImage,
  getDiSCImage,
  getDyslexiaPageImage,
  getEmotionalIntelligenceImage,
  getFourTemperamentsPersonalityTestImage,
  getHeroSectionEnneagramChartImage,
  getHighlySensitiveReportPageImage,
  getIndustryBannerImage,
  getLoveStylePageImage,
  getNPDReportPageImage,
  getPersonalityDisorderPlanImage,
  getPsycReportPageImage,
  likeabilityTraitColors,
  likeabilityTraitLabel,
} from "../utils/utility-functions";
import {
  ADHD_TEST_ASSESSMENT_ID,
  ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
  ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
  AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
  BIG_FIVE_TEST_ASSESSMENT_ID,
  BIPOLAR_DISORDER_ASSESSMENT_ID,
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID,
  DEPRESSION_TEST_ASSESSMENT_ID,
  DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
  DISC_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID,
  EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
  HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
  LIKEABILITY_TEST_ASSESSMENT_ID,
  LOVE_STYLE_TEST_ASSESSMENT_ID,
  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
  PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
  PERSONALITY_TEST_ASSESSMENT_ID,
  PSYCHOPATH_ASSESSMENT_ID,
  SOCIAL_ANXIETY_TEST_ASSESMENT_ID,
  AUTISM_CHILDREN_TEST_ASSESSMENT_ID,
} from "../utils/general-config";
import {
  getBigFiveTraitType,
  getOppositeTrait,
  getPersonalityType,
} from "../utils/personality-helper";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { LOCALE } from "../utils/constants";
import TraitProgressBar from "../components/trait-progress-bar/component";

function PlanAssessmentResults({
  enneagramKeyTraits,
  personalityName,
  personalityType,
  handleContinue,
  userTraits,
  assessmentId,
  personalityGroup,
  gender,
}) {
  const { t } = useTranslation();
  const isPersonalityTest = assessmentId === PERSONALITY_TEST_ASSESSMENT_ID;
  const isBigFiveTest = assessmentId === BIG_FIVE_TEST_ASSESSMENT_ID;
  const isEnneagramTest = assessmentId === ENNEAGRAM_TEST_ASSESSMENT_ID;
  const isLikeablityTest = assessmentId === LIKEABILITY_TEST_ASSESSMENT_ID;
  const isPersonalityDisorderTest =
    assessmentId === PERSONALITY_DISORDER_TEST_ASSESSMENT_ID;
  const isDiscPersonalityTest = assessmentId === DISC_TEST_ASSESSMENT_ID;
  const isEmotionalIntelligenceTest =
    assessmentId === EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID;
  const isAdhdTest = assessmentId === ADHD_TEST_ASSESSMENT_ID;
  const isAttachmentStyleTest =
    assessmentId === ATTACHMENT_STYLE_TEST_ASSESSMENT_ID;

  const isDifficultPersonTest =
    assessmentId === DIFFICULT_PERSON_TEST_ASSESSMENT_ID;

  const isAutismSpectrumTest =
    assessmentId === AUTISM_SPECTRUM_TEST_ASSESSMENT_ID;
  const isDyslexiaTestAdult =
    assessmentId === DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID;
  const isLoveStyleTest = assessmentId === LOVE_STYLE_TEST_ASSESSMENT_ID;
  const isCareerPreferenceTest =
    assessmentId === CAREER_PREFERENCE_TEST_ASSESSMENT_ID;

  const isHighlySensitivePersonTest =
    assessmentId === HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID;

  const isDyslexiaTestChildren =
    assessmentId === DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID;

  const isFourTempramentTest =
    assessmentId === FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID;

  const isNarcissisticPersonalityDisorderTest =
    assessmentId === NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID;

  const isAntiSocialPersonalityDisorderTest =
    assessmentId === ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID;

  const isDepressionTest = assessmentId === DEPRESSION_TEST_ASSESSMENT_ID;
  const isBipolarTest = assessmentId === BIPOLAR_DISORDER_ASSESSMENT_ID;
  const isPsychopathTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(PSYCHOPATH_ASSESSMENT_ID);
  const isChildhoodtraumaTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(CHILDHOOD_TRAUMA_TEST_ASSESSMENT_ID);

  const isSocialAnxietyTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(SOCIAL_ANXIETY_TEST_ASSESMENT_ID);

  const isAutismChildrenTest =
    !!assessmentId &&
    convertToLowerCase(assessmentId) ===
      convertToLowerCase(AUTISM_CHILDREN_TEST_ASSESSMENT_ID);

  return (
    <div>
      <PersonalityTraitsMessage
        isEnneagramTest={isEnneagramTest}
        isLikeablityTest={isLikeablityTest}
        isPersonalityDisorderTest={isPersonalityDisorderTest}
        isDiscPersonalityTest={isDiscPersonalityTest}
        isEmotionalIntelligenceTest={isEmotionalIntelligenceTest}
        isAdhdTest={isAdhdTest}
        isAttachmentStyleTest={isAttachmentStyleTest}
        isDifficultPersonTest={isDifficultPersonTest}
        isAutismSpectrumTest={isAutismSpectrumTest}
        isDyslexiaTestAdult={isDyslexiaTestAdult}
        isDyslexiaTestChildren={isDyslexiaTestChildren}
        personalityName={personalityName}
        personalityType={personalityType}
        handleContinue={handleContinue}
      />
      {isPersonalityTest && personalityName && personalityType && (
        <PersonalityResults
          userTraits={userTraits}
          assessmentId={assessmentId}
          t={t}
        />
      )}
      {isEnneagramTest && personalityName && personalityType && (
        <EnneagramResults
          enneagramKeyTraits={enneagramKeyTraits}
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isLikeablityTest && personalityName && personalityType && (
        <LikeabilityResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
          userTraits={userTraits}
        />
      )}
      {isBigFiveTest && personalityName && personalityType && (
        <BigFiveResults
          userTraits={userTraits}
          assessmentId={assessmentId}
          t={t}
        />
      )}
      {isPersonalityDisorderTest && personalityName && personalityType && (
        <PersonalityDisorderResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isDiscPersonalityTest && personalityName && personalityType && (
        <DisPersonalityResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isEmotionalIntelligenceTest && personalityName && personalityType && (
        <EmotionalIntelligenceResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isAdhdTest && personalityName && personalityType && (
        <ADHDResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isAttachmentStyleTest && personalityName && personalityType && (
        <AttachmentStyleResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isDifficultPersonTest && personalityName && personalityType && (
        <DifficultPersonResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isAutismSpectrumTest && personalityName && personalityType && (
        <AutismSpectrumResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isDyslexiaTestAdult && personalityName && personalityType && (
        <DyslexiaScreeningResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isLoveStyleTest && personalityName && personalityType && (
        <LoveStyleResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isCareerPreferenceTest && personalityName && personalityType && (
        <CareerPreferenceResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
          personalityGroup={personalityGroup}
          gender={gender}
        />
      )}
      {isHighlySensitivePersonTest && personalityName && personalityType && (
        <HighlySensitivePersonResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isDyslexiaTestChildren && personalityName && personalityType && (
        <DyslexiaScreeningChildrenResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isFourTempramentTest && personalityName && personalityType && (
        <FourTemperamentsResults
          personalityName={personalityName}
          personalityType={personalityType}
          handleContinue={handleContinue}
        />
      )}
      {isNarcissisticPersonalityDisorderTest &&
        personalityName &&
        personalityType && (
          <NarcissisticPersonalityDisorderResults
            personalityName={personalityName}
            personalityType={personalityType}
            handleContinue={handleContinue}
          />
        )}
      {isAntiSocialPersonalityDisorderTest &&
        personalityName &&
        personalityType && (
          <AntiSocialPersonalityResults
            personalityName={personalityName}
            personalityType={personalityType}
            handleContinue={handleContinue}
          />
        )}
      {isDepressionTest && personalityName && personalityType && (
        <DepressionPersonalityResults
          personalityName={personalityName}
          personalityType={personalityType}
        />
      )}
      {isBipolarTest && personalityName && personalityType && (
        <BipolarDisorderResults
          personalityName={personalityName}
          personalityType={personalityType}
        />
      )}

      {isPsychopathTest && personalityName && personalityType && (
        <PsychopathPersonalityResults
          personalityName={personalityName}
          personalityType={personalityType}
        />
      )}
      {isChildhoodtraumaTest && personalityName && personalityType && (
        <ChildhoodTraumaReport
          personalityName={personalityName}
          personalityType={personalityType}
        />
      )}
      {isSocialAnxietyTest && personalityName && personalityType && (
        <SocialAnxietyReport
          personalityName={personalityName}
          personalityType={personalityType}
        />
      )}
      {isAutismChildrenTest && personalityName && personalityType && (
        <AutismChildrenReport
          personalityName={personalityName}
          personalityType={personalityType}
        />
      )}
    </div>
  );
}

export default PlanAssessmentResults;

const EnneagramResults = ({
  enneagramKeyTraits,
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;

  const enttraits =
    enneagramKeyTraits.length > 0
      ? [
          {
            text: enneagramKeyTraits[0].Heading,
            color: "border-[#2092cb] text-[#2092cb]",
            bgClr: "bg-[#2092cb]",
          },
          {
            text: enneagramKeyTraits[1].Heading,
            color: "border-[#2db89e] text-[#2db89e]",
            bgClr: "bg-[#2db89e]",
          },
          {
            text: enneagramKeyTraits[2].Heading,

            color: "border-[#f9b337] text-[#f9b337]",
            bgClr: "bg-[#f9b337]",
          },
          {
            text: enneagramKeyTraits[3].Heading,
            color: "border-[#ed5a50] text-[#ed5a50]",
            bgClr: "bg-[#ed5a50]",
          },
        ]
      : [];

  return (
    <>
      {enneagramKeyTraits && personalityName && personalityType && (
        <div className="flex flex-row gap-4 mt-[10px]">
          <div className="text-center gap-3 flex flex-col justify-center items-center max-w-full">
            <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white">
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.common.personalized_results"),
                }}
              />
              <p>{t("plan.enneagram.description")}</p>
              <p>{t("plan.common.premium_perks")}</p>
            </div>
            <div className="flex flex-col md:flex-row items-start justify-between w-full py-4">
              <div className="w-full md:w-1/2 mt-6 md:mt-0 flex justify-center">
                <img
                  src={getHeroSectionEnneagramChartImage("plan", currentLocale)}
                  alt="Enneagram Maverick"
                  className="max-w-full h-auto max-h-64"
                />
              </div>
              <div className="max-w-sm p-4 mx-auto">
                <h2 className="text-lg font-bold mb-2 text-[#444C5E]">
                  {t("plan.enneagram.your_key_traits")}
                </h2>
                <ul className="space-y-2">
                  {enttraits.map((trait, index) => (
                    <li
                      key={index}
                      className={`flex items-center border-2 ${trait.color} pr-3`}
                    >
                      <div
                        className={`w-8 h-8 flex items-center justify-center ${trait.bgClr}`}
                      >
                        <svg
                          className="h-6 w-7 text-white"
                          viewBox="0 0 512 512"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94" />
                        </svg>
                      </div>
                      <span className="font-bold pl-2 uppercase">
                        {trait.text}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.enneagram.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const LikeabilityProgressBar = ({ label, percentage, color }) => {
  return (
    <li>
      <div className="flex justify-between items-center mb-2">
        <span className="font-semibold text-gray-700">{label}</span>
        <span className="text-sm" style={{ color }}>
          {percentage}%
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-5">
        <div
          className="h-5 rounded-full transition-all duration-500"
          style={{ width: `${percentage}%`, backgroundColor: color }}
        ></div>
      </div>
    </li>
  );
};

const LikeabilityResults = ({
  personalityName,
  personalityType,
  handleContinue,
  userTraits,
}) => {
  const { t } = useTranslation();

  const progressBarData = userTraits?.map(({ trait, percentage }) => ({
    label: likeabilityTraitLabel[trait.title], // Capitalize first letter
    percentage,
    color: likeabilityTraitColors[trait.title] || "rgba(0, 0, 0, 1)", // Default to black if not found
  }));

  return (
    <>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg">
          <div className="text-center gap-5 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.likeability.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="w-full flex justify-center">
              <img
                src={getPersonalityDisorderPlanImage("likeability")}
                alt="Personality Disorder"
                className="max-w-full"
              />
            </div>

            {/* <ul className="space-y-4 w-full">
              {progressBarData?.map((item, index) => (
                <LikeabilityProgressBar
                  key={index}
                  label={item.label}
                  percentage={item.percentage}
                  color={item.color}
                />
              ))}
            </ul> */}

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.likeability.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const PersonalityDisorderResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg ">
          <div className="text-center gap-3 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.personality_disorder.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="w-full flex justify-center py-2">
              <img
                src={getPersonalityDisorderPlanImage("personality-disorder")}
                alt="Personality Disorder"
                className="md:w-10/12 h-auto"
              />
            </div>

            <div className="flex justify-center items-center mt-4">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.personality_disorder.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DisPersonalityResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row gap-4 mt-[10px] lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-center max-w-full">
            <div className="relative z-10 text-[#444C5E]  text-[16px] lg:text-[20px] font-normal w-full bg-white">
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.common.personalized_results"),
                }}
              />
              <p>
                {t("plan.disc.description")} {t("plan.common.premium_perks")}
              </p>
            </div>

            <div className="w-full py-3 flex justify-center ">
              <img
                src={getDiSCImage("disc-report-1", currentLocale)}
                alt="Personality Disorder"
                className="w-80 md:w-10/12 h-auto"
              />
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.disc.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const EmotionalIntelligenceResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row gap-4 mt-[10px] lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-center max-w-full">
            <div className="relative z-10 text-[#444C5E]  text-[16px] lg:text-[20px] font-normal w-full bg-white">
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.common.personalized_results"),
                }}
              />
              <p>
                {t("plan.emotional_intelligence.description")}{" "}
                {t("plan.common.premium_perks")}
              </p>
            </div>

            <div className="w-full flex justify-center ">
              <img
                src={getEmotionalIntelligenceImage("ei-result-1")}
                alt="Personality Disorder"
                className="w-80 md:w-7/12 h-auto"
              />
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.emotional_intelligence.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ADHDResults = ({ personalityName, personalityType, handleContinue }) => {
  const { t } = useTranslation();

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg">
          <div className="text-center gap-6 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.adhd.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="flex justify-center h-56">
              <img
                src={getADHDImage("adhd-result-1")}
                alt="Personality Disorder"
              />
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.adhd.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const AttachmentStyleResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg">
          <div className="text-center gap-6 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.attachment_style.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="flex justify-center h-56">
              <img
                src={getAttachmentStyleReportPageImage("attachment-style-1")}
                alt="Personality Disorder"
              />
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.attachment_style.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DifficultPersonResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg">
          <div className="text-center gap-6 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.difficult_person.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="flex justify-center">
              <img
                src={getDifficultPersonImage("difficult-result-1")}
                alt="Personality Disorder"
              />
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.difficult_person.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const AutismSpectrumResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg">
          <div className="text-center gap-6 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.autism_spectrum.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="flex justify-center h-56">
              <img
                src={getAutismAdultReportPageImage("autism-1")}
                alt="Personality Disorder"
              />
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.autism_spectrum.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DyslexiaScreeningResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg">
          <div className="text-center gap-6 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.dyslexia.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="flex justify-center h-60">
              <img
                src={getDyslexiaPageImage("dyslexia-report-1")}
                alt="Personality Disorder"
              />
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.dyslexia.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const PersonalityTraitsMessage = ({
  isEnneagramTest,
  isLikeablityTest,
  isPersonalityDisorderTest,
  isDiscPersonalityTest,
  isEmotionalIntelligenceTest,
  isDyslexiaTestChildren,
  isAdhdTest,
  isAttachmentStyleTest,
  isDifficultPersonTest,
  isAutismSpectrumTest,
  isDyslexiaTestAdult,
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {!isEnneagramTest &&
        !isLikeablityTest &&
        !isPersonalityDisorderTest &&
        !isDiscPersonalityTest &&
        !isEmotionalIntelligenceTest &&
        !isAdhdTest &&
        !isAttachmentStyleTest &&
        !isDifficultPersonTest &&
        !isAutismSpectrumTest &&
        !isDyslexiaTestAdult &&
        !isDyslexiaTestChildren &&
        !personalityName &&
        personalityType && (
          <div className="flex flex-row gap-4 mt-[10px] justify-center items-center">
            <h2 className="text-center flex flex-col justify-center items-center max-w-full">
              <span className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full">
                {t("plan.personality_traits.free_traits")}
              </span>
              <span className="text-[#444C5E] font-semibold text-[20px] lg:text-[24px] w-full">
                &nbsp; {t("plan.common.click_continue.prefix")}{" "}
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.personality_traits.view_more")}
              </span>
            </h2>
          </div>
        )}
    </>
  );
};

const PersonalityResults = ({ userTraits, assessmentId, t }) => {
  const traitPercentagePersonality =
    userTraits &&
    userTraits?.map((item) => {
      return {
        ...item,
        percentage: item.percentage,
        leftTrait:
          item.percentage <= 50
            ? getPersonalityType(item?.trait?.title, t)
            : getOppositeTrait(item?.trait?.title, t),
        rightTrait:
          item.percentage > 50
            ? getPersonalityType(item?.trait?.title, t)
            : getOppositeTrait(item?.trait?.title, t),
        traitTitle: getPersonalityType(item?.trait?.title, t),
      };
    });
  return (
    <div className="flex flex-col gap-8 mt-10 mb-12 mx-4 lg:mx-0 text-[16px] relative z-10">
      {traitPercentagePersonality?.length &&
        traitPercentagePersonality?.map((item, index) => {
          return (
            <TraitProgressBar
              key={index}
              value={item.percentage}
              labelLeft={item.leftTrait}
              labelRight={item.rightTrait}
              text={item?.traitTitle}
              assessmentId={assessmentId}
              t={t}
            />
          );
        })}
    </div>
  );
};

const BigFiveResults = ({ userTraits, assessmentId, t }) => {
  const traitPercentageBigFive =
    userTraits &&
    userTraits?.map((item) => {
      return {
        ...item,
        percentage: item.percentage,
        leftTrait:
          item.percentage <= 50
            ? getBigFiveTraitType(item?.trait?.title, t)
            : getBigFiveTraitType(item?.trait?.title, t),
        rightTrait:
          item.percentage > 50
            ? getBigFiveTraitType(item?.trait?.title, t)
            : getBigFiveTraitType(item?.trait?.title, t),
        traitTitle: getBigFiveTraitType(item?.trait?.title, t),
      };
    });

  return (
    <div>
      <div className="flex flex-col gap-8 mt-6 mx-4 lg:mx-0 text-[16px]">
        {traitPercentageBigFive?.length &&
          traitPercentageBigFive?.map((item, index) => {
            return (
              <TraitProgressBar
                key={index}
                value={item.percentage}
                labelLeft={item.leftTrait}
                labelRight={item.rightTrait}
                text={item?.traitTitle}
                assessmentId={assessmentId}
                t={t}
              />
            );
          })}
      </div>
    </div>
  );
};

const LoveStyleResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();
  const result1ImageText = "love-style-report-1";
  const result1Image = getLoveStylePageImage(result1ImageText);
  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg ">
          <div className="text-center gap-3 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.love_style.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="w-full flex justify-center py-2">
              <img
                src={result1Image}
                alt="Personality Disorder"
                className="w-80 md:w-9/12 h-auto"
              />
            </div>

            <div className="flex justify-center items-center mt-4">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.love_style.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const CareerPreferenceResults = ({
  personalityName,
  personalityType,
  handleContinue,
  personalityGroup,
  gender,
}) => {
  const { t } = useTranslation();

  const resultImage = getIndustryBannerImage("career_academic");

  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row gap-4 mt-[10px] lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-center max-w-full">
            <div className="relative z-10 text-[#444C5E]  text-[16px] lg:text-[20px] font-normal w-full bg-white">
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.career_preference.report_title"),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.career_preference.description"),
                }}
              />
              {/* <p>{t("plan.common.premium_perks")}</p> */}
            </div>

            <div className="w-full py-3 flex justify-center ">
              <img
                src={resultImage}
                alt="Career Preference Report"
                className="md:w-9/12 h-auto"
              />
            </div>

            <div className="flex justify-center items-center ">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.career_preference.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const HighlySensitivePersonResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();
  const result1ImageText = "highly-sensitive-1";
  const result1Image = getHighlySensitiveReportPageImage(result1ImageText);

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg ">
          <div className="text-center gap-3 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.highly_sensitive_person.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="w-full flex justify-center">
              <img
                src={result1Image}
                alt="Highly Sensitive Person Report"
                className="md:w-8/12 h-auto"
              />
            </div>
            <div className="flex justify-center items-center mt-4">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.highly_sensitive_person.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DyslexiaScreeningChildrenResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();
  const result1ImageText = "dyslexia-report-1";
  const result1Image = getDyslexiaPageImage(result1ImageText);

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg ">
          <div className="text-center gap-3 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.dyslexia_screening_children.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="w-full flex justify-center">
              <img
                src={result1Image}
                alt="Highly Sensitive Person Report"
                className="md:w-7/12 h-auto"
              />
            </div>
            <div className="flex justify-center items-center mt-4">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.dyslexia_screening_children.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const FourTemperamentsResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  const banner1Image = getFourTemperamentsPersonalityTestImage(
    "4-temperments-results-1",
  );

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg ">
          <div className="text-center gap-3 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.four_temperaments.description",
                )} ${t("plan.common.premium_perks")}`,
              }}
            />

            <div className="w-full flex justify-center">
              <img
                src={banner1Image}
                alt="Highly Sensitive Person Report"
                className="md:w-11/12 h-auto"
              />
            </div>
            <div className="flex justify-center items-center mt-4">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.four_temperaments.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const NarcissisticPersonalityDisorderResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  const result1ImageText = "npd-results-1";
  const result1Image = getNPDReportPageImage(result1ImageText);

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg ">
          <div className="text-center gap-3 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t(
                  "plan.narcissistic_personality_disorder.heading",
                )} ${t("plan.narcissistic_personality_disorder.description")}`,
              }}
            />

            <div className="w-full flex justify-center">
              <img
                src={result1Image}
                alt="Highly Sensitive Person Report"
                className="md:w-10/12 h-auto"
              />
            </div>
            <div className="flex justify-center items-center mt-4">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.narcissistic_personality_disorder.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const AntiSocialPersonalityResults = ({
  personalityName,
  personalityType,
  handleContinue,
}) => {
  const { t } = useTranslation();

  const result1ImageText = "antisocial-results-1";
  const result1Image = getAntiSocialReportPageImage(result1ImageText);

  return (
    <div>
      {personalityName && personalityType && (
        <div className="w-full lg:max-w-lg ">
          <div className="text-center gap-3 flex flex-col justify-center items-center w-full">
            <span
              className="text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full"
              dangerouslySetInnerHTML={{
                __html: `${t("plan.common.personalized_results")} ${t(
                  "plan.antisocial_personality_disorder.description",
                )}`,
              }}
            />

            <div className="w-full flex justify-center">
              <img
                src={result1Image}
                alt="Highly Sensitive Person Report"
                className="md:w-10/12 h-auto"
              />
            </div>
            <div className="flex justify-center items-center mt-4">
              <span className="text-[#444C5E] font-semibold text-[16px] lg:text-[20px]">
                &nbsp;{" "}
                <span className="font-semibold text-[20px] lg:text-[24px]">
                  {t("plan.common.click_continue.prefix")}
                </span>
                <span
                  className="text-[#805AED] text-[20px] lg:text-[24px] cursor-pointer font-semibold"
                  onClick={handleContinue}
                >
                  {t("plan.common.click_continue.continue_text")}
                </span>{" "}
                {t("plan.common.click_continue.suffix")}{" "}
                {t("plan.antisocial_personality_disorder.report_name")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DepressionPersonalityResults = ({ personalityName, personalityType }) => {
  const { t } = useTranslation();

  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row  lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-start max-w-full ">
            <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white ">
              {/* Personalized Results Text */}
              <p
                className=""
                dangerouslySetInnerHTML={{
                  __html: t("plan.depression_text.long_text"),
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const BipolarDisorderResults = ({ personalityName, personalityType }) => {
  const { t } = useTranslation();
  const bipolardisorder1 = "bipolar-1";
  const bipolardisorderImage1 = getBipolarDisorderImage(bipolardisorder1);

  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row  lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-start max-w-full ">
            <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white ">
              {/* Personalized Results Text */}
              <p
                className=""
                dangerouslySetInnerHTML={{
                  __html: t("plan.bipolar_text.long_text"),
                }}
              />
              <div className="w-full flex justify-center mt-5">
                <img
                  src={bipolardisorderImage1}
                  alt="Bipolar"
                  className="md:w-10/12 h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const PsychopathPersonalityResults = ({ personalityName, personalityType }) => {
  const { t } = useTranslation();
  const result1ImageText = "psyc-result-1";
  const result1Image = getPsycReportPageImage(result1ImageText);

  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row  lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-start max-w-full ">
            <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white mt-2">
              {/* Personalized Results Text */}
              <p
                className=""
                dangerouslySetInnerHTML={{
                  __html: t("plan.psychopath_text.long_text"),
                }}
              />
              <div className="w-full flex justify-center mt-5">
                <img
                  src={result1Image}
                  alt="Bipolar"
                  className="md:w-10/12 h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ChildhoodTraumaReport = ({ personalityName, personalityType }) => {
  const { t } = useTranslation();
  const result1ImageText = "cht-result-1";
  const result1Image = getChildhoodPageImage(result1ImageText);

  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row  lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-start max-w-full ">
            <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white ">
              {/* Personalized Results Text */}
              <p
                className=""
                dangerouslySetInnerHTML={{
                  __html: t("plan.childhood_text.long_text"),
                }}
              />
              <div className="w-full flex justify-center mt-5">
                <img
                  src={result1Image}
                  alt="Bipolar"
                  className="md:w-10/12 h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const SocialAnxietyReport = ({ personalityName, personalityType }) => {
  const { t } = useTranslation();
  const result1Image = getSocialAnxietyReportPageImage("sat-result-1");

  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row  lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-start max-w-full ">
            <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white ">
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.social_anxiety_text.heading"),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.social_anxiety_text.description"),
                }}
              />
              <div className="w-full flex justify-center mt-5">
                <img
                  src={result1Image}
                  alt="Social Anxiety"
                  className="md:w-10/12 h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const AutismChildrenReport = ({ personalityName, personalityType }) => {
  const { t } = useTranslation();
  const result1ImageText = "act-result-1";
  const result1Image = getAutismChildPageImage(result1ImageText);

  return (
    <div>
      {personalityName && personalityType && (
        <div className="flex flex-row  lg:max-w-lg">
          <div className="text-center gap-3 flex flex-col justify-center items-start max-w-full ">
            <div className="relative z-10 text-[#444C5E] text-[16px] lg:text-[20px] font-normal w-full bg-white ">
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.autism_children_text.heading"),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t("plan.autism_children_text.description"),
                }}
              />

              <div className="w-full flex justify-center mt-5">
                <img
                  src={result1Image}
                  alt="Autism Children Report"
                  className="md:w-10/12 h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
